import currency from "currency.js";

export function defaultMoneyFormat(value: number | string) {
  return currency(parseFloat(value as string), {
    decimal: ",",
    symbol: "",
    separator: "",
  }).format();
}

export function roundTwoDigits(value: number | string) {
  const v = parseFloat(value as string);
  return Math.round(v * 100) / 100;
}

export function renderMoney(value: number | string) {
  let v = defaultMoneyFormat(roundTwoDigits(value));
  if (parseFloat(v) < 0) {
    v = "0";
  }
  return `${v} zł`;
}
